export default __webpack_public_path__ + "static/media/sticker-delta.9ee9cff6.png";